import { ILocation } from '@rbi-ctg/frontend';

export type NativeLocation = null | false | ILocation;

/**
 * Detects if the user is on an iOS device (iPhone, iPad, or iPod) based on the user agent string.
 * Replaced usage of deprecated `navigator.platform` with `navigator.userAgent`.
 * Works with both modern and older browsers, provided `userAgent` is exposed.
 */
export function isIOSWeb(userAgent: string): boolean {
  return /iPhone|iPad|iPod/i.test(userAgent);
}

export function joinCoordinates(location: NativeLocation): string {
  return location ? `${location.lat},${location.lng}` : '';
}

export function nativeMapsHref(
  origin: NativeLocation | null,
  destination: false | ILocation = false
) {
  const isIOS = isIOSWeb(navigator.userAgent);
  const scheme = isIOS ? 'maps' : 'https';

  const destCoords = joinCoordinates(destination);

  if (!origin) {
    return isIOS
      ? `${scheme}://?daddr=${destCoords}`
      : `${scheme}://www.google.com/maps/search/?api=1&query=${destCoords}`;
  }

  const originCoords = joinCoordinates(origin);

  const url = isIOS
    ? `${scheme}://?saddr=${originCoords}&daddr=${destCoords}`
    : `${scheme}://www.google.com/maps/dir/?api=1&origin=${originCoords}&destination=${destCoords}`;

  return url;
}

export function openNativeMaps(origin: NativeLocation, destination: false | ILocation = false) {
  window.open(nativeMapsHref(origin, destination));
}

declare interface IBillingAddress {
  city: string;
  street: string;
  country: string;
  postalCode: string;
  state: string;
}
export const buildFormattedBillingAddress = ({
  city,
  street,
  country,
  postalCode,
  state,
}: IBillingAddress) => {
  return `${street}, ${city}, ${state}, ${postalCode}, ${country}`;
};
